import React from 'react';
import PropTypes from 'prop-types';

import { currency } from 'utils/currency';
import DefaultImage from 'pages/MyAccount/shared-components/DefaultImage/DefaultImage';
import { ReactComponent as SurpriseMeIcon } from './surprise-me-icon.svg';
import defaultImage from './default-image.png';
import styles from './styles.module.scss';

const Product = ({ name, brandName, title, imageUrl, price, quantity, autoAssigned, slug }) => {
  const productName = brandName ? `${brandName} ${name}` : name;
  const displayedName = autoAssigned ? 'Mystery Surprise' : productName;
  const productUrl = slug ? `/product/${slug}` : null;

  return (
    <li className={styles.product} data-testid="product-list-item">
      <div>
        {autoAssigned ? (
          <SurpriseMeIcon className={styles.surprise} />
        ) : (
          <a href={productUrl} target="_blank" rel="noreferrer">
            <figure>
              <DefaultImage src={imageUrl} defaultImage={defaultImage} alt={displayedName} />
            </figure>
          </a>
        )}
      </div>
      <div className={styles['product-text']}>
        <h3>{displayedName}</h3>
        {quantity && (
          <p data-testid="product-quantity-price">
            Qty: {quantity}
            <span>|</span>
            {currency.format(price)}
          </p>
        )}
        {title && <p>{title}</p>}
      </div>
    </li>
  );
};

Product.propTypes = {
  name: PropTypes.string.isRequired,
  brandName: PropTypes.string,
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  price: PropTypes.number,
  quantity: PropTypes.number,
  autoAssigned: PropTypes.bool,
  slug: PropTypes.string,
};

Product.defaultProps = {
  brandName: null,
  title: null,
  imageUrl: null,
  price: null,
  quantity: null,
  autoAssigned: false,
  slug: null,
};

export default Product;
